// extracted by mini-css-extract-plugin
export default {"styled":"SubmissionConfirmation_styled__n1hBW","centerHeader":"SubmissionConfirmation_centerHeader__zOVZy"};